/** Large monospace digit boxes for a ride pickup OTP. */
export function OtpDisplay({ code = '0000' }: { code?: string }) {
  return (
    <div
      className="wb-otp-code"
      role="group"
      aria-label={`Pickup code ${code.split('').join(' ')}`}
    >
      {code.split('').map((d, i) => (
        <span key={i} className="wb-otp-digit">
          {d}
        </span>
      ))}
    </div>
  );
}
